export const goalTypesByEntity = {
  individual: [
    { value: 'find_job', label: 'Find a Job' },
    { value: 'upskill', label: 'Upskill' },
    { value: 'get_certified', label: 'Get Certified' },
    { value: 'find_mentor', label: 'Find a Mentor' },
    { value: 'contribute_expertise', label: 'Contribute Expertise' },
    { value: 'peer_collaboration', label: 'Peer Collaboration' },
    { value: 'custom', label: 'Custom Goal' }
  ],
  university: [
    { value: 'improve_placements', label: 'Improving student placements' },
    { value: 'industry_partnerships', label: 'Building industry partnerships' },
    { value: 'curriculum_alignment', label: 'Aligning curriculum with industry' },
    { value: 'research_collaborations', label: 'Finding research collaborations' },
    { value: 'attract_students', label: 'Attracting prospective students' },
    { value: 'announce_program', label: 'Announce new program/course' },
    { value: 'custom', label: 'Custom Goal' }
  ],
  organization: [
    { value: 'hire_talent', label: 'Hire skilled talent' },
    { value: 'workforce_training', label: 'Train workforce' },
    { value: 'skill_gap_analysis', label: 'Skill gap analysis' },
    { value: 'partner_institutes', label: 'Partner with training institutes' },
    { value: 'find_consultants', label: 'Find consultants/experts' },
    { value: 'announce_jobs', label: 'Announce job openings' },
    { value: 'custom', label: 'Custom Goal' }
  ],
  institute: [
    { value: 'attract_learners', label: 'Attract learners' },
    { value: 'corporate_clients', label: 'Get corporate training clients' },
    { value: 'curriculum_development', label: 'Develop curriculum' },
    { value: 'industry_certifications', label: 'Offer industry certifications' },
    { value: 'partner_universities', label: 'Partner with universities' },
    { value: 'announce_batch', label: 'Announce new batch/course' },
    { value: 'custom', label: 'Custom Goal' }
  ]
};

export function getGoalTypesForEntity(entityType) {
  return goalTypesByEntity[entityType] || goalTypesByEntity.individual;
}
